import React, { useEffect, useState, Suspense } from "react";
import ComponentOne from "./ComponentOne";
import Registration from "./Registration";
import ComponentTwo from "./ComponentTwo";
import HeroSection from "./hero-section/HeroSection";
import PushNotificationLayout from "../PushNotificationLayout";
import AppDownloadSection from "./app-download-section/index";
import { useGeolocated } from "react-geolocated";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import MapModal from "../Map/MapModal";
import { ModuleSelection } from "./hero-section/module-selection";
import useGetModule from "../../api-manage/hooks/react-query/useGetModule";
import Banners from "./Banners";
import { NoSsr, useMediaQuery, useTheme, Skeleton, Box } from "@mui/material";
import DiscountBanner from "./DiscountBanner";
import CookiesConsent from "../CookiesConsent";
import WhatsAppWidget from "../WhatsAppWidget";

const LandingPage = ({ configData, landingPageData }) => {
  const Testimonials = React.lazy(() => import("./Testimonials"));
  const router = useRouter();
  const theme = useTheme();
  const [location, setLocation] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [openModuleSelection, setOpenModuleSelection] = useState(false);
  const { refetch: moduleRefetch } = useGetModule();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
    isGeolocationEnabled: true,
  });
  useEffect(() => {
    setLocation(JSON.stringify(localStorage.getItem("location")));
  }, []);
  const handleClose = () => {
    setOpen(false);
  };

  const handleLocationSet = () => {
    // Fetch modules immediately after setting location (same as hero section)
    moduleRefetch();

    // Close map modal
    setOpen(false);

    // Show module selection (same as hero section)
    setOpenModuleSelection(true);
  };

  const handleCloseModuleSelection = (selectedModule) => {
    setOpenModuleSelection(false);
    if (selectedModule) {
      // Module was selected, navigate to home
      router.push("/home", undefined, { shallow: true });
    }
  };

  const handleOrderNow = () => {
    if (location) {
      if (location === "null") {
        setOpen(true);
      } else {
        // Location is selected, show module selection instead of navigating to home
        setOpenModuleSelection(true);
      }
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <PushNotificationLayout>
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.background.default,
            width: "100%",
            flex: "1 1 auto",
          }}
        >
        <HeroSection
          configData={configData}
          landingPageData={landingPageData}
          handleOrderNow={handleOrderNow}
        />
        <WhatsAppWidget />
        <ComponentOne
          landingPageData={landingPageData}
          configData={configData}
          handleOrderNow={handleOrderNow}
        />
        {landingPageData?.promotion_banners?.length > 0 && (
          <Banners landingPageData={landingPageData} isSmall={isSmall} />
        )}
        <ComponentTwo
          configData={configData}
          landingPageData={landingPageData}
        />
        {(landingPageData?.earning_title ||
          landingPageData?.earning_sub_title ||
          landingPageData?.earning_seller_title ||
          landingPageData?.earning_seller_sub_title ||
          landingPageData?.earning_dm_title ||
          landingPageData?.earning_dm_sub_title) && (
            <Registration data={landingPageData} isSmall={isSmall} />
          )}
        {landingPageData?.fixed_promotional_banner && (
          <DiscountBanner
            bannerImage={`${landingPageData?.base_urls?.promotional_banner_url}/${landingPageData?.fixed_promotional_banner}`}
            isSmall={isSmall}
          />
        )}
        {(landingPageData?.business_title ||
          landingPageData?.business_sub_title ||
          landingPageData?.business_image) && (
            <AppDownloadSection
              configData={configData}
              landingPageData={landingPageData}
            />
          )}
        {landingPageData?.testimonial_list?.length > 0 && (
          <Suspense fallback={<Skeleton variant="rectangular" height={400} sx={{ borderRadius: "16px", marginTop: "2rem" }} />}>
            <Testimonials landingPageData={landingPageData} isSmall={isSmall} />
          </Suspense>
        )}
        {open && (
          <MapModal
            open={open}
            handleClose={handleClose}
            coords={coords}
            disableAutoFocus
            onLocationSet={handleLocationSet}
          />
        )}
        {openModuleSelection && (
          <ModuleSelection
            location={true} // Pass true to indicate location is available
            closeModal={handleCloseModuleSelection}
            disableAutoFocus
            fromsignup={false}
          />
        )}
        <NoSsr>
          <CookiesConsent text={configData?.cookies_text} />
        </NoSsr>
        </Box>
      </PushNotificationLayout>
    </>
  );
};

export default LandingPage;
